import { ProductFeature } from '@localstack/types';

export const FEATURE_NAME_MAPPING: Record<ProductFeature, string> = {
  [ProductFeature.FEATURE_SCIM]: 'SCIM',
  [ProductFeature.FEATURE_SSO]: 'SSO',
  [ProductFeature.FEATURE_PODS]: 'Owned Cloud Pods',
  [ProductFeature.FEATURE_PODS_PUBLIC]: 'Public Cloud Pods',
  [ProductFeature.FEATURE_STACKS_PREVIEW]: 'Basic Stack Insights',
  [ProductFeature.FEATURE_STACKS_PREMIUM]: 'Extended Stack Insights',
  [ProductFeature.FEATURE_CI_PROJECTS]: 'CI Projects',
  [ProductFeature.FEATURE_COMPUTE]: 'Ephemeral Instances',
  [ProductFeature.FEATURE_LOCALSTACK_PRO]: 'LocalStack Pro Activation',
  [ProductFeature.FEATURE_LOCALSTACK_EXTENSION]: 'LocalStack Extension',
  [ProductFeature.FEATURE_LOCALSTACK_PLUGIN]: 'LocalStack Plugin',
  [ProductFeature.FEATURE_LOCALSTACK_AWS_PROVIDER]: 'LocalStack AWS Provider',
  [ProductFeature.FEATURE_LOCALSTACK_CONTAINER_RUNTIME]: 'LocalStack Container Runtimes',
  [ProductFeature.FEATURE_LOCALSTACK_LAMBDA_RUNTIME_EXECUTOR]: 'LocalStack Lambda Runtime Executors',
  [ProductFeature.FEATURE_LOCALSTACK_K8S_OPERATOR]: 'LocalStack Kubernetes Operator',
  [ProductFeature.FEATURE_SNOWFLAKE]: 'LocalStack Snowflake Emulator',
  [ProductFeature.FEATURE_SNOWFLAKE_RUST_PREVIEW]: 'LocalStack Snowflake Emulator (Rust Preview)',
  [ProductFeature.FEATURE_LOCALSTACK_PODS_REMOTE]: 'LocalStack Pod Remotes',
  [ProductFeature.FEATURE_LOCALSTACK_GLUE_JOB_EXECUTOR]: 'LocalStack Glue Job Executor',
  [ProductFeature.FEATURE_LOCALSTACK_APPINSPECTOR]: 'LocalStack App Inspector',
  [ProductFeature.FEATURE_AZURE_PREVIEW]: 'LocalStack Azure Emulator (Preview)',
  [ProductFeature.FEATURE_PLATFORM_LOGGING]: 'SSO/SCIM Log Records',
  [ProductFeature.FEATURE_USAGE_INSIGHTS]: 'Usage Insights',
};
